import Default from "./Default";

export default {
  default: Default,
};
